// src/utils/poRoles.js
// HIGH-01 (29 Oct 2026) - who may do what with a purchase order, in ONE place.
// WHY: the approver list existed three times (PO Detail, PO List, the service)
// and amend / reassign had no role check at all. Pages and services import
// these lists; firestore.rules (match /purchase_orders) mirrors them by hand -
// change both together.
// 'admin' is only in PO_APPROVER_ROLES (kept as it was, Ravi 29 Oct, mismatch E):
// it is not one of the 7 app roles and the rules give it nothing.

export const PO_CREATE_ROLES     = ["owner", "sm", "manager", "store"];
export const PO_APPROVER_ROLES   = ["sm", "owner", "admin", "manager"];
export const PO_AMEND_ROLES      = ["owner", "sm", "manager"];
export const PO_REASSIGN_ROLES   = ["owner", "sm", "manager"];
export const PO_GRN_ROLES        = ["owner", "sm", "manager", "store"];
export const SITE_FINALIZE_ROLES = ["owner", "sm", "manager"];
export const PO_VIEW_ROLES       = ["owner", "sm", "manager", "store", "accounts"];

// Who gets the PO list page. Route only, NOT mirrored in firestore.rules: the
// rules' read is poViewRoles, which also has accounts (accounts open a single
// PO by its link, never the list). Matches the sidebar item in MainLayout.js.
export const PO_LIST_ROLES       = ["owner", "sm", "manager", "store"];

// Is this role in the list? EXACT match - no lower-casing, no trimming - the
// same as the rules (callerRole() in [...]), so a screen offers an action only
// when the rules would accept it ("Admin", "Manager", "manager " -> false).
// An empty or missing role is never in a list.
export const hasPoRole = (list, role) =>
  Array.isArray(list) && typeof role === "string" && role !== "" && list.includes(role);

// The 50 keys buildPurchaseOrderDoc() (purchaseOrderService.js) writes on a
// new PO - the create rule's keys().hasOnly([...]) is this same list.
// purchaseOrderService.test.js checks the real builder against it.
export const PO_CREATE_KEYS = [
  "company_id", "purchase_mode", "project_id", "project_name", "site_id", "site_name",
  "site_confirmation_status", "site_confirmed_items", "site_confirmed_by", "site_confirmed_by_name",
  "site_confirmed_at", "assigned_site_engineer_ids", "po_number", "po_status", "approval_status",
  "receive_status", "created_at", "updated_at", "vendor_id", "vendor_name", "vendor_email", "vendor_phone",
  "vendor_address", "vendor_gst", "vendor_gst_registered", "source_purchase_request_id", "source_type",
  "source", "grn_locked", "over_received", "short_closed", "delivery_date", "priority", "transport",
  "remarks", "notes", "created_by", "created_by_name", "updated_by", "subtotal", "gst_total",
  "discount_total", "grand_total", "freight_amount", "landed_grand_total", "total_items",
  "received_items", "pending_items", "completion_percentage", "items",
];
